export enum QUICK_MOVE_DIRECTION {
  LEFT = 1,
  RIGHT,
}

export enum SEQUENCE_MODE_TYPE {
  VIEW = 1,
  EDIT,
}

export enum LEADING_COLOR_CHANGE_TYPE {
  INSERT = 1,
  UPDATE,
  DELETE,
  NOUPDATE,
}

export enum PRODUCT_ATTRIBUTE_CHANGE_TYPE {
  INSERT = 1,
  UPDATE,
  DELETE,
}

export enum COLOR_MANAGEMENT_VIEW_TYPE {
  ALL = 1,
  PUBLISHED,
  UNPUBLISHED,
}

export const MetricsList = [
  { label: "Price", value: "Price" },
  { label: "Inventory", value: "Inventory" },
  { label: "Item Sales", value: "Item Sales" },
  { label: "Items Sold", value: "Items Sold" },
  { label: "Conversion Rate", value: "Conversion Rate" },
  { label: "Items Abandoned", value: "Items Abandoned" },
  { label: "Abandonment Rate", value: "Abandonment Rate" },
  { label: "Product Views", value: "Product Views" },
  { label: "Stock Value", value: "Stock Value" },
  { label: "SKU Coverage", value: "SKU Coverage" },
];

export const AnalyticsOnlyMetrics = [
  "Item Sales",
  "Items Sold",
  "Conversion Rate",
  "Items Abandoned",
  "Abandonment Rate",
  "Product Views",
];

export const PAGINATION_CHUNK_SIZE = 30;

export enum FACET_ACTION_TYPE {
  DELETE = 0,
  BLOCK,
}

export const CATALOG_NAVIGATION_TABS = {
  PRODUCTS: "products",
  SUB_CATEGORIES: "subcategories",
  LEAF_CATEGORIES: "leafcategories",
  FACETS: "facets",
  LINKED_CATEGORIES: "linkedcategories",
};

export const REPORT_TYPE_NAVIGATION_TABS = {
  PRODUCT: "product",
  CATEGORY: "category",
};

export const BUSINESS_RULES_NAVIGATION_TABS = {
  SORTING_RULES: "sorting-rules",
  AUTOMATION_RULES: "automation-rules",
};

export const FACET_BUCKET_MODES = {
  VALUES: "VALUES",
  THRESHOLDS: "THRESHOLDS",
  PERIODS: "PERIODS",
  NONE: "NONE",
};

export const OVERLAY_TABS = {
  PRODUCTS: "products",
  PRODUCTS_BADGES: "productsBadges",
  ANALYTICS_OVERLAY: "analyticsOverlay",
  RATINGS: "ratings",
  SMAI: "smai",
  CATEGORIES_OVERLAY: "categoriesOverlay",
  INVENTORY_OVERLAY: "inventoryOverlay",
  ATTRIBUTES_OVERLAY: "attributesOverlay",
};

export const PRODUCT_TILE_HEIGHTS = new Map([
  [2, 425],
  [3, 425],
  [4, 425],
  [5, 425],
  [6, 425],
]);

export const PRODUCT_TILE_HEIGHTS_SKELETON = new Map([
  [2, 442],
  [3, 442],
  [4, 342],
  [5, 342],
  [6, 302],
]);

export const PRODUCT_TILE_WIDTH_SKELETON = new Map([
  [2, 49],
  [3, 32],
  [4, 24],
  [5, 19],
  [6, 15.5],
]);

export const CURRENCY_MAP = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  CHF: "CHF",
  JPY: "¥",
  CNY: "¥",
  KRW: "₩",
  CAD: "$",
  AUD: "$",
  NZD: "$",
  SGD: "$",
  BRL: "R$",
  RUB: "руб",
  RON: "lei",
  PLN: "zł",
};

export const PRODUCT_IMAGE_BADGE_MARGIN_TOP = new Map([
  [2, 150],
  [3, 150],
  [4, 80],
  [5, 50],
  [6, 0],
]);

export const scoringFormulaTypes = [
  {
    label: "Take the highest of all the points",
    value: "HI",
  },
  {
    label: "Take the lowest of all the points",
    value: "LO",
  },
  {
    label: "Take the average of all the points",
    value: "AVG",
  },
  {
    label: "Take the sum of all the points",
    value: "SUM",
  },
];

export const periodTypes = [
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 14 days", value: "last_14_days" },
  {
    label: "Last 30 days",
    value: "last_30_days",
  },
  {
    label: "Last 90 days",
    value: "last_90_days",
  },
  {
    label: "Last 180 days",
    value: "last_180_days",
  },
];
export const sortByOrder = [
  { label: "Asc", value: "ASC" },
  { label: "Desc", value: "DESC" },
];
export const repeats = [
  { label: "Daily", value: "Daily" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
];

export const repeatDays = [
  {
    label: "Monday",
    value: "MON",
  },
  {
    label: "Tuesday",
    value: "TUE",
  },
  {
    label: "Wednesday",
    value: "WED",
  },
  {
    label: "Thursday",
    value: "THU",
  },
  {
    label: "Friday",
    value: "FRI",
  },
  {
    label: "Saturday",
    value: "SAT",
  },
];

export const retries = [
  {
    label: 0,
    value: 0,
  },
  {
    label: 1,
    value: 1,
  },
  {
    label: 2,
    value: 2,
  },
  {
    label: 3,
    value: 3,
  },
];

export const IAutomationRepeats = {
  WEEKLY: "Weekly",
  DAILY: "Daily",
  MONTHLY: "Monthly",
};

export const IAutomationEndDuration = {
  ON: "On",
  NEVER: "Never",
};

export const DEFAULT_SORT_PERIOD_VALUE = "last_7_days";

export const VARIATION_GROUP = "Variation Group";

export const analyticMetrics = [
  "Item Sales",
  "Items Sold",
  "Conversion Rate",
  "Items Abandoned",
  "Abandonment Rate",
  "Product Views",
];

export const calculateIconSize = (column: number): number => {
  switch (column) {
    case 2:
      return 2.5;
    case 3:
      return 2.188;
    case 4:
      return 1.875;
    case 5:
      return 1.563;
    default:
      return 1.25;
  }
};

export const calculateIconSizeForContentSlot = (column: number): number => {
  switch (column) {
    case 2:
      return 1.5;
    case 3:
      return 1.3;
    case 4:
      return 1.05;
    case 5:
      return 0.9;
    default:
      return 0.7;
  }
};

export const BoostBuryList = [
  { label: "Bury-score products to bottom", value: "buried" },
  { label: "Boost-score products to top", value: "boosted" },
];

export const SmartSortList = [
  { label: "Out-of-stock products to bottom", value: "out-of-stock" },
  { label: "New products to top", value: "new-products" },
  { label: "Discounted products to bottom", value: "discounted-products" },
  { label: "Unpublished products to bottom", value: "unpublished-products" },
];

export const SmartSortValues = {
  bury: "buried",
  boost: "boosted",
  outOfStock: "out-of-stock",
  newProducts: "new-products",
  discountedProducts: "discounted-products",
  unpublishedProducts: "unpublished-products",
};

export const SMART_SORT_RULE_IDS = {
  OUT_OF_STOCK: "*outofstock",
  NEW: "*new",
  DISCOUNTED: "*discounted",
  BOOSTED: "*boosted",
  BURIED: "*buried",
  UNPUBLISHED: "*unpublished",
} as const;

export const SmartSortingRulesList = [
  {
    label: "Out-of-stock products to bottom",
    value: SMART_SORT_RULE_IDS.OUT_OF_STOCK,
  },
  { label: "New products to top", value: SMART_SORT_RULE_IDS.NEW },
  {
    label: "Discounted products to bottom",
    value: SMART_SORT_RULE_IDS.DISCOUNTED,
  },
  { label: "Bury-score products to bottom", value: SMART_SORT_RULE_IDS.BURIED },
  { label: "Boost-score products to top", value: SMART_SORT_RULE_IDS.BOOSTED },
  {
    label: "Unpublished products to bottom",
    value: SMART_SORT_RULE_IDS.UNPUBLISHED,
  },
];

export const steps = [
  "Read File",
  "Select Store",
  "Select Catalog",
  "Download",
  "Upload Links",
];

export const PERFORMANCE_NAVIGATION_TABS = {
  EXECUTIVE_SUMMARY: "executive-summary",
  TRAFFIC: "traffic",
  PRODUCT: "product",
  CONVERSION: "conversion",
  REVENUE: "revenue",
};

export const KPI_PRODUCT_OPTIONS = [
  { label: "Top Viewed", value: "Top Viewed" },
  // { label: "Top Added-to-Cart", value: "Top Added-to-Cart" },
  { label: "Top Selling by Revenue", value: "Top Selling by Revenue" },
  { label: "Top Selling by Volume", value: "Top Selling by Volume" },
  { label: "Hidden Gems", value: "Hidden Gems" },
  { label: "Traffic Jams", value: "Traffic Jams" },
];

export const KPI_PRODUCT_METRICS_OPTIONS = [
  {
    label: "Top Viewed",
    value: "productViews",
    sortDescending: true,
    type: "number",
  },
  {
    label: "Top Added-to-Cart",
    value: "productsAddedToCart",
    sortDescending: true,
    type: "number",
  },
  {
    label: "Top Selling by Revenue",
    value: "itemSales",
    sortDescending: true,
    type: "currency",
  },
  {
    label: "Top Selling by Volume",
    value: "itemsSold",
    sortDescending: true,
    type: "number",
  },
  {
    label: "Hidden Gems",
    value: ["orderToViewRate", "itemsSold", "productViews"],
    sortBy: [
      { metricId: "orderToViewRate", desc: true },
      { metricId: "productViews", desc: false },
    ],
    type: "ordersAndViews",
  },
  {
    label: "Traffic Jams",
    value: ["orderToViewRate", "itemsSold", "productViews"],
    sortBy: [
      { metricId: "orderToViewRate", desc: false },
      { metricId: "productViews", desc: true },
    ],
    type: "ordersAndViews",
  },
];

export const KPI_PRODUCT_METRIC_LABELS = [
  { label: "Top Viewed", value: "Views" },
  { label: "Top Added-to-Cart", value: "ATC" },
  { label: "Top Selling by Revenue", value: "Revenue" },
  { label: "Top Selling by Volume", value: "Items" },
  { label: "Hidden Gems", value: "Orders / View" },
  { label: "Traffic Jams", value: "Orders / View" },
];
